import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bt-idle',
    templateUrl: './idle.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./idle.component.scss']
})
export class IdleComponent implements OnInit, OnDestroy {

	private readonly fullPageClass = 'bt-fullpage-mode';

	constructor() { }

	ngOnInit(): void {
		this.addClassIfNotExists();
	}

	ngOnDestroy(): void {
		this.removeClassIfExists();
	}

	private addClassIfNotExists(): void {
		if (!document.body.classList.contains(this.fullPageClass)) {
			document.body.classList.add(this.fullPageClass);
		}
	}

	private removeClassIfExists(): void {
		if (document.body.classList.contains(this.fullPageClass)) {
			document.body.classList.remove(this.fullPageClass);
		}
	}

	public refresh() {
		window.location.reload();
	}

}
